module.exports = __webpack_public_path__ + "img/dumschat.db80f8cb.png";